var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneratedDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 1.65675C0.835845 1.2847 0.984694 0.928608 1.24765 0.665392C1.5106 0.402175 1.86654 0.252967 2.23859 0.25H27.7612C28.5376 0.25 29.1666 0.880417 29.1666 1.65675V24.3432C29.164 24.7153 29.0151 25.0714 28.7522 25.3346C28.4892 25.5978 28.1333 25.747 27.7612 25.75H2.23859C1.86574 25.7496 1.50829 25.6012 1.24478 25.3375C0.981268 25.0737 0.833252 24.7161 0.833252 24.3432V1.65675ZM9.33325 3.08333V22.9167H20.6666V3.08333H9.33325ZM3.66659 3.08333V5.91667H6.49992V3.08333H3.66659ZM23.4999 3.08333V5.91667H26.3333V3.08333H23.4999ZM3.66659 8.75V11.5833H6.49992V8.75H3.66659ZM23.4999 8.75V11.5833H26.3333V8.75H23.4999ZM3.66659 14.4167V17.25H6.49992V14.4167H3.66659ZM23.4999 14.4167V17.25H26.3333V14.4167H23.4999ZM3.66659 20.0833V22.9167H6.49992V20.0833H3.66659ZM23.4999 20.0833V22.9167H26.3333V20.0833H23.4999Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratedDuration);
export default __webpack_public_path__ + "static/media/Generated-Duration.f4c5b675c66c9c28d1918743da0ceb8f.svg";
export { ForwardRef as ReactComponent };